export enum TargetDocumentType {
  SAME_DOCUMENT = 'SAME_DOCUMENT',
  DIFFERENT_DOCUMENT = 'DIFFERENT_DOCUMENT',
}
